import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    variant: 'bodyRegular',
  },

  styleOverrides: {
    root: {
      variants: [
        {
          props: { uppercase: true },
          style: {
            textTransform: 'uppercase',
          },
        },
        {
          props: { color: 'primary' },
          style: {
            color: scssVariables.ColorNavy100,
          },
        },
      ],
    },
  },
};
